import {get, post, patch, del} from './http';

export type P0SlackChannel = {
  id: string;
  name: string;
  enabled: boolean;
  created_by: string;
  created_at: string;
  modified_by: string | null;
  modified_at: string | null;
};

export type CreateP0SlackChannelRequest = {
  name: string;
  webhook_url: string;
  enabled?: boolean;
};

export type UpdateP0SlackChannelRequest = {
  name?: string;
  webhook_url?: string;
  enabled?: boolean;
};

export const p0SlackChannelsApi = {
  list: async () => get<P0SlackChannel[]>('/p0-slack-channels'),

  create: async (body: CreateP0SlackChannelRequest) =>
    post<CreateP0SlackChannelRequest, P0SlackChannel>('/p0-slack-channels', body),

  update: async (id: string, body: UpdateP0SlackChannelRequest) =>
    patch<UpdateP0SlackChannelRequest, P0SlackChannel>(`/p0-slack-channels/${id}`, body),

  delete: async (id: string) => del(`/p0-slack-channels/${id}`)
};
